import { render } from "./FinanceiroDetalhes.vue?vue&type=template&id=18d459c6"
import script from "./FinanceiroDetalhes.vue?vue&type=script&lang=js"
export * from "./FinanceiroDetalhes.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__